import { TelegramAuthForm } from '@features/auth-by-telegram'
import IMG1 from '@shared/assets/loginImg1.png'
import IMG2 from '@shared/assets/loginImg2.png'
import IMG3 from '@shared/assets/loginImg3.png'
import { Carousel, Col, Flex, Image, Layout, Row, Space, theme, Typography } from 'antd'

const { Title, Text } = Typography

export const LoginPage = () => {
    const {
        token: { colorBgContainer }
    } = theme.useToken()

    return (
        <Layout style={{ height: '100vh' }}>
            <Row>
                <Col span={12} style={{ backgroundColor: colorBgContainer }}>
                    <Title style={{ position: 'absolute', top: 0, left: 15 }} level={3}>
                        TelegaPlan
                    </Title>
                    <Flex align={'center'} style={{ height: '100vh' }}>
                        <div style={{ margin: 'auto', width: 475 }}>
                            <Title level={1}>CRM для эффективного управления каналами в телеграм </Title>
                            <Space
                                direction="vertical"
                                onClick={() => {
                                    if (typeof window !== 'undefined' && window.ym) {
                                        ym(104127916, 'reachGoal', 'click-visit-to-tg')
                                    }
                                }}
                            >
                                <Text>
                                    Удобный инструмент оптимизации и получения статистики для администраторов телеграмм
                                    каналов
                                </Text>
                                <Text strong>Пожалуйста, авторизуйтесь</Text>
                                <TelegramAuthForm />
                            </Space>
                        </div>
                    </Flex>
                </Col>
                <Col
                    span={12}
                    style={{
                        height: '100%',
                        background: `linear-gradient(99.37deg, #06345B 5.38%, #063359 10%, #063257 14.14%, #063055 17.98%, #052F52 21.68%, #052D4F 25.43%, #052B4B 29.39%, #052846 33.75%, #042541 38.68%, #04223B 44.36%, #031E34 50.95%, #03192C 58.63%, #021423 67.58%, #020E19 77.98%, #01070D 90%, #000000 103.81%)`
                    }}
                >
                    <Carousel autoplay>
                        <div>
                            <div
                                style={{
                                    margin: '50px auto 0px',
                                    width: '602px',
                                    height: '668px',
                                    textAlign: 'center'
                                }}
                            >
                                <Image preview={false} src={IMG1} />
                            </div>
                        </div>
                        <div>
                            <div
                                style={{
                                    margin: '100px auto 0px',
                                    width: '453px',
                                    height: '600px',
                                    textAlign: 'center'
                                }}
                            >
                                <Image preview={false} src={IMG2} />
                            </div>
                        </div>
                        <div>
                            <div
                                style={{
                                    margin: '10px auto 0px',
                                    width: '433px',
                                    height: '600px',
                                    textAlign: 'center'
                                }}
                            >
                                <Image preview={false} src={IMG3} />
                            </div>
                        </div>
                    </Carousel>
                </Col>
            </Row>
        </Layout>
    )
}
